import { Typography } from '@mui/material';
import moment from 'moment';
import {
	AutocompleteArrayInput,
	Datagrid,
	DateField,
	Filter,
	FunctionField,
	NumberField,
	ReferenceArrayInput,
	TextField,
	useListContext,
	usePermissions,
} from 'react-admin';
import { ArrayChipInput, CustomizableDatagrid } from '../../components';
import { BetweenDatesTimesInput } from '../../components/BetweenDatesInput';
import Permission from '../../components/Permission';
import ReportList from '../../components/ReportList';
import { PERMISSIONS } from '../../constants';
import { formatAttendantLabel, filterToQuery } from '../../utils';

const titleSx = {
	margin: '10px 0 10px 0',
	textAlign: 'center',
	fontWeight: 'bold'
};

const fuelTypeChoices = [
	{ id: 1, name: 'Etanol' },
	{ id: 2, name: 'Diesel' },
	{ id: 3, name: 'Diesel S10' },
	{ id: 4, name: 'GNV' },
	{ id: 5, name: 'Gasolina' },
	{ id: 6, name: 'Gasolina Aditivada' },
	{ id: 7, name: 'Arla 32' },
];

const DeliveriesList = () => {
	const props = useListContext();

	let data = [];
	let summaryData = [];

	if (props.data) {
		const deliveryInfo = props.data[0];
		if (deliveryInfo) {
			data = deliveryInfo.data;
			summaryData = [deliveryInfo.summaryData];
		}
	}

	return (
		<>
			<Typography sx={titleSx}>Total</Typography>
			<Datagrid
				bulkActionButtons={false}
				style={{ marginBottom: 60 }}
				data={summaryData}
				total={1}
			>
				<NumberField
					source="total_value"
					label="Total em Valor"
					textAlign="center"
					emptyText="R$ 0,00"
					options={{
						style: 'currency',
						currency: 'BRL',
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}}
					sortable={false}
				/>
				<NumberField
					source="total_volume"
					label="Total em Litros"
					textAlign="center"
					emptyText="0"
					options={{
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}}
					sortable={false}
				/>
				<TextField source="total_deliveries" textAlign="center" label="Total de abastecimentos" sortable={false} />
				<NumberField
					source="average_ticket"
					label="Ticket Médio"
					textAlign="center"
					emptyText="R$ 0,00"
					options={{
						style: 'currency',
						currency: 'BRL',
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}}
					sortable={false}
				/>
				<NumberField
					source="average_volume"
					label="Volume Médio"
					textAlign="center"
					emptyText="0"
					options={{
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}}
					sortable={false}
				/>
				<NumberField
					source="average_price"
					label="Preço Médio"
					textAlign="center"
					emptyText="R$ 0,000"
					options={{
						style: 'currency',
						currency: 'BRL',
						minimumFractionDigits: 3,
						maximumFractionDigits: 3
					}}
					sortable={false}
				/>
			</Datagrid>

			<Typography sx={titleSx}>Abastecimentos (Concentrador)</Typography>
			<CustomizableDatagrid
				resource={props.resource}
				data={data}
				total={props.total}
				bulkActionButtons={false}
				defaultColumns={['station_numeric_id', 'fuel_name', 'value', 'volume', 'price', 'hose_number', 'attendant_name', 'received_at']}
			>
				<TextField
					source="station_numeric_id"
					label="ID Posto"
					textAlign="center"
				/>
				<TextField
					source="fuel_name"
					label="Combustível"
					emptyText="--"
				/>
				<TextField
					source="fuel_type_description"
					label="Tipo Combustível"
					emptyText="--"
				/>
				<NumberField
					source="value"
					label="Valor"
					textAlign="center"
					emptyText="R$ 0,00"
					options={{
						style: 'currency',
						currency: 'BRL',
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}}
				/>
				<NumberField
					source="volume"
					label="Litros"
					textAlign="center"
					emptyText="0"
					options={{
						maximumFractionDigits: 3
					}}
				/>
				<NumberField
					source="price"
					label="Preço/Litro"
					textAlign="center"
					emptyText="R$ 0,000"
					options={{
						style: 'currency',
						currency: 'BRL',
						minimumFractionDigits: 3,
						maximumFractionDigits: 3
					}}
				/>
				<NumberField
					source="hose_number"
					label="Bico"
					textAlign="center"
					emptyText="--"
				/>
				<NumberField
					source="fuel_point_number"
					label="Ponto"
					textAlign="center"
					emptyText="--"
				/>
				<NumberField
					source="encerrante_start"
					label="Encerrante Início"
					textAlign="center"
					emptyText="--"
					options={{
						maximumFractionDigits: 3
					}}
				/>
				<NumberField
					source="encerrante_end"
					label="Encerrante Fim"
					textAlign="center"
					emptyText="--"
					options={{
						maximumFractionDigits: 3
					}}
				/>
				<TextField
					source="tank_name"
					label="Tanque"
					emptyText="--"
				/>
				<TextField
					source="attendant_tag"
					label="Tag Frentista"
					emptyText="--"
				/>
				<TextField
					source="attendant_name"
					label="Frentista"
					emptyText="--"
				/>
				<TextField
					source="customer_tag"
					label="Tag Cliente"
					emptyText="--"
				/>
				<TextField
					source="customer_name"
					label="Cliente"
					emptyText="--"
				/>
				<TextField
					source="provider_name"
					label="Fornecedor"
					emptyText="--"
				/>
				<FunctionField
					source="fillin_id"
					label="Vinculado"
					render={record => record?.fillin_id ? 'Sim' : 'Não'}
				/>
				<TextField
					source="auth_id"
					label="ID Autorização"
					emptyText="--"
				/>
				<TextField
					source="delivery_id"
					label="ID Delivery"
					textAlign="center"
				/>
				<DateField source="created_at" label="Data Concentrador" showTime />
				<DateField source="received_at" label="Recebido em" showTime />
				<DateField source="operational_date" label="Data Operacional" showTime />
			</CustomizableDatagrid>
		</>
	);
}

const deliveriesExporter = async (data) => {
	const deliveryInfo = data[0]?.data || [];
	return deliveryInfo.map(delivery => ({
		'ID Delivery': delivery.delivery_id,
		'ID Posto': delivery.station_numeric_id,
		'Combustível': delivery.fuel_name,
		'Tipo': delivery.fuel_type_description,
		'Valor': delivery.value,
		'Litros': delivery.volume,
		'Preço/Litro': delivery.price,
		'Bico': delivery.hose_number,
		'Ponto': delivery.fuel_point_number,
		'Encerrante Início': delivery.encerrante_start,
		'Encerrante Fim': delivery.encerrante_end,
		'Tanque': delivery.tank_name,
		'Tag Frentista': delivery.attendant_tag,
		'Frentista': delivery.attendant_name,
		'Tag Cliente': delivery.customer_tag,
		'Cliente': delivery.customer_name,
		'Fornecedor': delivery.provider_name,
		'Vinculado': delivery.fillin_id ? 'Sim' : 'Não',
		'Data Concentrador': delivery.created_at,
		'Recebido em': delivery.received_at,
		'Data Operacional': delivery.operational_date,
	}));
}

const HoseNumberChip = (props) => {
	const record = props.record;
	if (!record) return null;
	return <span>{record}</span>;
}

const ListFilters = (props) => {
	return (
		<Filter {...props}>
			<BetweenDatesTimesInput alwaysOn />
			<ReferenceArrayInput
				source="stationIds"
				reference="stations"
				perPage={null}
				sort={{ field: "name", order: "ASC" }}
				alwaysOn
			>
				<AutocompleteArrayInput
					filterToQuery={filterToQuery}
					label="Postos"
					optionText="name"
					style={{ minWidth: 200 }}
				/>
			</ReferenceArrayInput>
			<ReferenceArrayInput
				source="attendantIds"
				reference="attendants"
				label="Frentistas"
				perPage={null}
				sort={{ field: "name", order: "ASC" }}
			>
				<AutocompleteArrayInput
					filterToQuery={filterToQuery}
					label="Frentistas"
					optionText={record => formatAttendantLabel(record)}
					style={{ minWidth: 200 }}
				/>
			</ReferenceArrayInput>
			<ArrayChipInput source="fuelTypes" label="Tipos de Combustível" type="number" />
			<ArrayChipInput source="hoseNumbers" label="Bicos" type="number" />
		</Filter>
	);
}

const FilterTablePrint = () => {
	const { filterValues } = useListContext();
	return (
		<Datagrid data={[{ ...filterValues, generatedReportAt: moment().toISOString() }]} total={1} bulkActionButtons={false}>
			<DateField source="from" textAlign="center" label="De" sortable={false} />
			<DateField source="to" textAlign="center" label="Até" sortable={false} />
			<DateField source="generatedReportAt" textAlign="center" label="Gerado às" showTime sortable={false} />
		</Datagrid>
	);
}

const ReportDeliveries = (props) => {
	const filterDefaultValues = {
		from: moment().startOf('day').toISOString(),
		to: moment().endOf('day').toISOString(),
	};

	return (
		<Permission permission={PERMISSIONS.ADMIN}>
			<ReportList periodRequired
				{...props}
				basePath="deliveries"
				title="Abastecimentos (Todos)"
				resource="reports/deliveries"
				filters={<ListFilters />}
				sort={{ field: 'received_at', order: 'DESC' }}
				filterDefaultValues={filterDefaultValues}
				bulkActionButtons={false}
				customExporter={deliveriesExporter}
				titleOnPrint="Relatório de abastecimentos - Todos"
				filterTablePrint={<FilterTablePrint />}
				showFilterButton
				landscape
			>
				<DeliveriesList />
			</ReportList>
		</Permission>
	);
};

export default ReportDeliveries;
